<template>
  <div id="cont">
    <div id="content">

    </div>
    <!-- 1.为echars准备一个定义好宽高的盒子 -->
   
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "",
  data() {
    return {
      da: [
        50.9,  11.1, 18.7, 48.3, 69.2, 231.6, 46.6, 55.4, 18.4, 10.3, 10
      ],
      dates:[],
      GoldPrice:[], //au999典当
      GoldPriceduan:[], //au999断当

      PTPrice:[], //铂金
    };
  },
  watch: {
    dates() {
      this.myEchars()
    }
    },
  created(){
     this.getDate()
  },
  mounted() {
    this.myEchars();
    //  this.getDate()

  },
  
  methods: {
    myEchars() {
      // 2.基于准备好的dom  初始化 echars 实例
      let  myChart = this.$echarts.init(
        document.getElementById("content")
      );
      var option;
      // 3、准备数据和配置项
     const colors = ['#5470C6', '#EE6666','#000000'];
option = {
  color: colors,
  tooltip: {
    trigger: 'none',
    axisPointer: {
      type: 'cross'
    }
  },
  legend: {},
  grid: {
    top: 75,
    bottom: 50
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: '#000000'
        }
      },
      axisPointer: {
        label: {
          formatter: function (params) {
            return (
              '长安.双庆 典当行价格' +
              params.value +
              (params.seriesData.length ? '：' + params.seriesData[0].data : '')
            );
          }
        }
      },
      // prettier-ignore
      data: this.dates
    },
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: colors[0]
        }
      },
      // axisPointer: {
      //   label: {
      //     formatter: function (params) {
      //       return (
      //         'Precipitation  ' +
      //         params.value +
      //         (params.seriesData.length ? '：' + params.seriesData[0].data : '')
      //       );
      //     }
      //   }
      // },
      // prettier-ignore
      // data: ['2015-1', '2015-2', '2015-3', '2015-4', '2015-5', '2015-6', '2015-7', '2015-8', '2015-9', '2015-10', '2015-11', '2015-12']
    }
  ],
  yAxis: [
    {
      type: 'value',
       axisLabel: {
        formatter: '{value} 元'
      }
    }
  ],
  series: [
    {
      name: '黄金Au999典当价格',
      type: 'line',
      xAxisIndex: 1,
      smooth: true,
      emphasis: {
        focus: 'series'
      },
      data: this.GoldPrice
    },
    {
      name: '黄金Au999断当价格',
      type: 'line',
      smooth: true,
      emphasis: {
        focus: 'series'
      },
      data: this.GoldPriceduan
    },
     {
      name: '铂金PT999典当价格',
      type: 'line',
      smooth: true,
      emphasis: {
        focus: 'series'
      },
      data: 
        this.PTPrice
      
    }
  ]
};


      option && myChart.setOption(option);
    },

  //拿到从今天到往前10天的日期
  getDate(){
    for(let d=0; d<10;d++){
      //  let a =  dayjs().subtract(d, 'day').format('YYYY-MM-DD')
        // this.dates.push(a)
         let newDate =  dayjs().subtract(d, 'day').format('YYYYMMDD')

      this.getGoldPrice(newDate)
      this.getPT(newDate)
    }
    
  },
  //拿到金价
  getGoldPrice(date){
     this.axios
        .get("/getGold/?app=finance.shgold_history", {
          params: {
            goldid: "1053",
            date:date,
            // version: 3,
            appkey: "62349",
            sign: "2b467d69432566985eec8e93f82e9008",
            format: "json",
          },
        }).then(res=>{
          if(res.data.success!=="0"){
              let test = []
            test.push(res.data.result.lists[0])
     
            test.sort(function(a,b){
              return a[0].days - b[0].days
            })

            this.dates.push(test[0].days)
            this.GoldPrice.push(Math.trunc(test[0].yesy_price-25))
            this.GoldPriceduan.push(Math.trunc(test[0].yesy_price-10))


          }
          

          

          
          // this.GoldPrice.push(res.data.)
        })
  },

  //  铂金价格
    getPT(date){
       this.axios
        .get("/getGold/?app=finance.shgold_history", {
          params: {
            goldid: "1056",
            date:date,
            // version: 3,
            appkey: "62349",
            sign: "2b467d69432566985eec8e93f82e9008",
            format: "json",
          },
        })
        .then(res=>{
          if(res.data.success!=="0"){
              let test = []
            test.push(res.data.result.lists[0])
     
            test.sort(function(a,b){
              return a[0].days - b[0].days
            })

            // this.dates.push(test[0].days)
            this.PTPrice.push(Math.trunc(test[0].yesy_price-30))
            // this.PTPriceduan.push(Math.trunc(test[0].yesy_price*0.85))


          }
        })
    }
    



  },



};
</script>

<style scoped>
#content {
  width: 100%;
  height: 800px;
  margin: 10px auto;
}
</style>

